import React, { Component } from "react";
import { Link } from "react-router-dom";
import emailjs from "emailjs-com";
import Header from "../layout/header";
import Footer4 from "../layout/footer4";
import ReCAPTCHA from "react-google-recaptcha";
import ScrollToTop from "../element/scrollToTop";

const bg = require("../../images/banner/bnr3.webp");

class Contact2 extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      phone: "",
      mobile: "",
      email: "",
      message: "",
      alertMessage: "",
      alertType: "",
      captchaToken: "", // New state for captcha token
    };
  }

  // Handle input change
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // Handle captcha change
  handleRecaptchaChange = (token) => {
    this.setState({ captchaToken: token });
  };

  // Function to send the email
  sendEmail = (e) => {
    e.preventDefault();

    if (!this.state.captchaToken) {
      this.setState({
        alertMessage: "Please complete the captcha verification.",
        alertType: "danger",
      });
      return;
    }

    const serviceID = "service_28emj8y";
    const templateID = "template_2rotnxq";
    const userID = "IDZukK49bAWi8Pkt0";

    const templateParams = {
      name: this.state.name,
      phone: this.state.phone,
      mobile: this.state.phone,
      email: this.state.email,
      message: this.state.message
    };

    emailjs.send(serviceID, templateID, templateParams, userID).then(
      (result) => {
        console.log(result.text);
        this.setState({
          alertMessage: "Email sent successfully!",
          alertType: "success",
          name: "",
          phone: "",
          mobile: "",
          email: "",
          message: "",
          captchaToken: "", // Reset captcha token after successful submission
        });
      },
      (error) => {
        console.log(error.text);
        this.setState({
          alertMessage: "Failed to send email. Please try again.",
          alertType: "danger",
        });
      }
    );
  };

  render() {
    const {
      name,
      phone,
      email,
      message,
      alertMessage,
      alertType,
      captchaToken,
    } = this.state;

    return (
      <>
        <Header />
        <div className="page-content bg-white">
          {/* --- SIMPLE & CLEAN MINI BANNER --- */}
          <div 
            className="dlab-bnr-inr overlay-black-middle text-center"
            style={{ 
              height: "45vh", 
              minHeight: "350px", 
              backgroundImage: "url(" + bg + ")",
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              textAlign: "center"
            }}
          >
            <div className="container" style={{ zIndex: 5, position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
              <div style={{ animation: "fadeUp 1s ease-out", width: "100%" }}>
                <span style={{ color: "#ff4b2b", fontSize: "14px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "3px", display: "block", marginBottom: "15px" }}>Get In Touch</span>
                <h1 style={{ color: "white", fontSize: "3.5rem", fontWeight: "800", marginBottom: "20px", textShadow: "0 4px 15px rgba(0,0,0,0.4)" }}>
                  Contact Us
                </h1>
                <div style={{ width: "60px", height: "4px", background: "#ff4b2b", margin: "0 auto", borderRadius: "2px" }}></div>
              </div>
            </div>
            
            {/* Subtle curved divider */}
            <div style={{ position: "absolute", bottom: "-1px", left: 0, width: "100%", overflow: "hidden", lineHeight: 0 }}>
              <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ position: "relative", display: "block", width: "calc(100% + 1.3px)", height: "40px" }}>
                <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5,73.84-4.36,147.54,16.88,218.2,35.26,69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113,14.29,1200,52.47V0Z" fill="#ffffff" opacity=".25"></path>
                <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" fill="#ffffff" opacity=".5"></path>
                <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.41,78.3,34.2,160.25,37.78,242.09,13.67,61.8-18.2,123.47-52.61,188.91-58.8V0Z" fill="#ffffff"></path>
              </svg>
            </div>
          </div>

          <style dangerouslySetInnerHTML={{__html: `
            @keyframes fadeUp {
              from { opacity: 0; transform: translateY(30px); }
              to { opacity: 1; transform: translateY(0); }
            }
            .contact-card:hover {
              transform: translateY(-10px);
              box-shadow: 0 20px 40px rgba(0,0,0,0.1) !important;
            }
            .social-icon:hover {
              background: #ff4b2b !important;
              color: #fff !important;
              transform: scale(1.1);
            }
            .form-control:focus {
              border-color: #ff4b2b !important;
              box-shadow: 0 0 0 3px rgba(255, 75, 43, 0.1) !important;
              background: #fff !important;
            }
          `}} />

          <div className="section-full content-inner contact-page-8" style={{ paddingTop: '80px', paddingBottom: '80px', background: 'linear-gradient(180deg, #fff 0%, #f9f9f9 100%)' }}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12 m-b30">
                  <div className="row">
                    {/* Company Address */}
                    <div className="col-lg-3 col-md-6 col-sm-6 m-b30">
                      <div className="icon-bx-wraper expertise p-a30 radius-sm contact-card" style={{ 
                        background: '#fff', 
                        boxShadow: '0 10px 30px rgba(0,0,0,0.05)', 
                        borderRadius: '15px',
                        height: '100%',
                        transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
                        border: '1px solid #eee'
                      }}>
                        <div className="icon-content text-center">
                          <div className="icon-sm text-primary m-b20 m-auto" style={{ 
                            width: '60px', 
                            height: '60px', 
                            background: 'rgba(255, 75, 43, 0.1)', 
                            borderRadius: '15px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            color: '#ff4b2b'
                          }}>
                            <i className="ti-location-pin" style={{ fontSize: '28px' }}></i>
                          </div>
                          <h5 className="dlab-tilte m-b10" style={{ fontWeight: '700', color: '#222', letterSpacing: '0.5px' }}>Address</h5>
                          <p style={{ fontSize: '14px', color: '#555', lineHeight: '1.6' }}>
                            Survey No.1754, Nr Plasma Induction (INDIA) Pvt Ltd<br/>
                            Hajipur Kalol, Dist-Gandhinagar-382721
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* E-mail */}
                    <div className="col-lg-3 col-md-6 col-sm-6 m-b30">
                      <div className="icon-bx-wraper expertise p-a30 radius-sm contact-card" style={{ 
                        background: '#fff', 
                        boxShadow: '0 10px 30px rgba(0,0,0,0.05)', 
                        borderRadius: '15px',
                        height: '100%',
                        transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
                        border: '1px solid #eee'
                      }}>
                        <div className="icon-content text-center">
                          <div className="icon-sm text-primary m-b20 m-auto" style={{ 
                            width: '60px', 
                            height: '60px', 
                            background: 'rgba(255, 75, 43, 0.1)', 
                            borderRadius: '15px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            color: '#ff4b2b'
                          }}>
                            <i className="ti-email" style={{ fontSize: '28px' }}></i>
                          </div>
                          <h5 className="dlab-tilte m-b10" style={{ fontWeight: '700', color: '#222', letterSpacing: '0.5px' }}>E-mail</h5>
                          <a href="mailto:mkt@castomech.com" style={{ fontSize: '15px', color: '#ff4b2b', fontWeight: '600' }}>
                            mkt@castomech.com
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Phone */}
                    <div className="col-lg-3 col-md-6 col-sm-6 m-b30">
                      <div className="icon-bx-wraper expertise p-a30 radius-sm contact-card" style={{ 
                        background: '#fff', 
                        boxShadow: '0 10px 30px rgba(0,0,0,0.05)', 
                        borderRadius: '15px',
                        height: '100%',
                        transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
                        border: '1px solid #eee'
                      }}>
                        <div className="icon-content text-center">
                          <div className="icon-sm text-primary m-b20 m-auto" style={{ 
                            width: '60px', 
                            height: '60px', 
                            background: 'rgba(255, 75, 43, 0.1)', 
                            borderRadius: '15px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            color: '#ff4b2b'
                          }}>
                            <i className="ti-mobile" style={{ fontSize: '28px' }}></i>
                          </div>
                          <h5 className="dlab-tilte m-b10" style={{ fontWeight: '700', color: '#222', letterSpacing: '0.5px' }}>Phone</h5>
                          <a href="tel:+919054005999" style={{ fontSize: '14px', color: '#555', display: 'block', marginBottom: '5px', fontWeight: '500' }}>+91 90540 05999</a>
                          <a href="tel:+919033304845" style={{ fontSize: '14px', color: '#555', fontWeight: '500' }}>+91 90333 04845</a>
                        </div>
                      </div>
                    </div>

                    {/* Social */}
                    <div className="col-lg-3 col-md-6 col-sm-6 m-b30">
                      <div className="icon-bx-wraper expertise p-a30 radius-sm contact-card" style={{ 
                        background: '#fff', 
                        boxShadow: '0 10px 30px rgba(0,0,0,0.05)', 
                        borderRadius: '15px',
                        height: '100%',
                        transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
                        border: '1px solid #eee'
                      }}>
                        <div className="icon-content text-center">
                          <div className="icon-sm text-primary m-b20 m-auto" style={{ 
                            width: '60px', 
                            height: '60px', 
                            background: 'rgba(255, 75, 43, 0.1)', 
                            borderRadius: '15px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            color: '#ff4b2b'
                          }}>
                            <i className="ti-desktop" style={{ fontSize: '28px' }}></i>
                          </div>
                          <h5 className="dlab-tilte m-b10" style={{ fontWeight: '700', color: '#222', letterSpacing: '0.5px' }}>Connect</h5>
                          <div className="d-flex align-items-center justify-content-center">
                            <a href="https://www.facebook.com/CASTOMECH?mibextid=ZbWKwL" target="_blank" className="m-r10 social-icon" style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#3b5998', transition: 'all 0.3s' }}>
                              <i className="fa fa-facebook"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/castomech-technology/" target="_blank" className="m-r10 social-icon" style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0077b5', transition: 'all 0.3s' }}>
                              <i className="fa fa-linkedin"></i>
                            </a>
                            <a href="https://www.instagram.com/castomechtechnology?igsh=MTQ5OWN2NXd2bWdjYw==" target="_blank" className="social-icon" style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#e4405f', transition: 'all 0.3s' }}>
                              <i className="fa fa-instagram"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-7 col-md-12 m-b30">
                  <div style={{ background: '#fff', padding: '50px', borderRadius: '25px', boxShadow: '0 30px 60px rgba(0,0,0,0.06)', border: '1px solid #f0f0f0' }}>
                    <form className="inquiry-form" onSubmit={this.sendEmail}>
                      <div className="section-head style-1 m-b30">
                        <span style={{ color: '#ff4b2b', fontSize: '13px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '2px', display: 'block', marginBottom: '10px' }}>Inquiry</span>
                        <h2 className="title" style={{ fontSize: '32px', fontWeight: '800', marginBottom: '15px', color: '#111' }}>Let's Build Something Great</h2>
                        <div style={{ width: '50px', height: '4px', background: '#ff4b2b', borderRadius: '2px' }}></div>
                        <p className="m-t15" style={{ color: '#777', fontSize: '15px' }}>Fill out the form below and our team will get back to you within 24 hours.</p>
                      </div>

                      {alertMessage && (
                        <div className={`alert alert-${alertType} m-b30`} style={{ borderRadius: '12px', padding: '15px 20px', fontSize: '14px', fontWeight: '500' }}>
                          <i className={`fa ${alertType === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'} m-r10`}></i>
                          {alertMessage}
                        </div>
                      )}

                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group m-b25">
                            <label style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '10px', display: 'block' }}>FULL NAME</label>
                            <input name="name" type="text" value={name} onChange={this.handleChange} required className="form-control" placeholder="John Doe" style={{ height: '55px', borderRadius: '12px', border: '1px solid #eef0f2', padding: '0 25px', fontSize: '15px', background: '#f8fafc', transition: 'all 0.3s' }} />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group m-b25">
                            <label style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '10px', display: 'block' }}>PHONE NUMBER</label>
                            <input name="phone" type="text" value={phone} onChange={this.handleChange} required className="form-control" placeholder="+91 00000 00000" style={{ height: '55px', borderRadius: '12px', border: '1px solid #eef0f2', padding: '0 25px', fontSize: '15px', background: '#f8fafc', transition: 'all 0.3s' }} />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group m-b25">
                            <label style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '10px', display: 'block' }}>EMAIL ADDRESS</label>
                            <input name="email" type="email" value={email} onChange={this.handleChange} required className="form-control" placeholder="example@mail.com" style={{ height: '55px', borderRadius: '12px', border: '1px solid #eef0f2', padding: '0 25px', fontSize: '15px', background: '#f8fafc', transition: 'all 0.3s' }} />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group m-b30">
                            <label style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '10px', display: 'block' }}>TELL US MORE</label>
                            <textarea name="message" rows="4" value={message} onChange={this.handleChange} required className="form-control" placeholder="Tell us about your requirements..." style={{ borderRadius: '12px', border: '1px solid #eef0f2', padding: '20px 25px', fontSize: '15px', background: '#f8fafc', transition: 'all 0.3s', resize: 'none' }}></textarea>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group m-b30">
                            <div style={{ transform: 'scale(1.02)', transformOrigin: '0 0' }}>
                              <ReCAPTCHA sitekey="6LfJfAgpAAAAAKxWLLAbkYw9Vx1U-WN9fPi66Nsu" onChange={this.handleRecaptchaChange} />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <button type="submit" disabled={!captchaToken} className="site-button btn-block button-md" style={{ 
                            height: '60px',
                            borderRadius: '12px', 
                            background: captchaToken ? '#ff4b2b' : '#cbd5e1', 
                            border: 'none', 
                            color: '#fff',
                            padding: '0', 
                            fontWeight: '800', 
                            fontSize: '17px', 
                            letterSpacing: '1px',
                            boxShadow: captchaToken ? '0 15px 30px rgba(255, 75, 43, 0.3)' : 'none',
                            transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
                            cursor: captchaToken ? 'pointer' : 'not-allowed'
                          }}>
                            {captchaToken ? 'SEND MESSAGE' : 'VERIFY CAPTCHA TO SEND'}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="col-lg-5 col-md-12 m-b30">
                  <div style={{ height: '100%', minHeight: '500px', borderRadius: '25px', overflow: 'hidden', boxShadow: '0 30px 60px rgba(0,0,0,0.06)', border: '1px solid #f0f0f0' }}>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4833.041577819477!2d72.42459389999999!3d23.1788566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c20d4a3396a23%3A0xf99389f1e6f5056c!2sCASTOMECH%20TECHNOLOGY!5e1!3m2!1sen!2sin!4v1773660899652!5m2!1sen!2sin"
                      width="100%"
                      height="100%"
                      style={{ border: 0, filter: 'grayscale(0.2) contrast(1.1)' }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer4 />
        <ScrollToTop className="icon-up" />
      </>
    );
  }
}

export default Contact2;
